export default __webpack_public_path__ + "static/media/cafemambo.3687d9e7.jpg";